import React from 'react';
import DrMaxReserveMedicamentsListItem, { Medicament } from './DrMaxReserveMedicamentsListItem';
import Text from '../../../BaseModule/Components/Text';
// @ts-ignore
import styles from "./DrMaxReserveMedicamentsList.module.scss";
import PillButton from '../../../BaseModule/Components/Button/PillButton/PillButton';
import DrMaxPill from '../../../BaseModule/Components/Pills/DrMaxPill';

interface Props {
	items: Medicament[];
}

const DrMaxReserveMedicamentsList: React.FC<Props> = ({items}) => {
	return (
		<div className={styles.list}>
			<Text tx={'component.drmax.prescriptionContents'} className={styles.title}/>
			{items.map((item, index) => {
				return (
					<React.Fragment key={index}>
							<DrMaxReserveMedicamentsListItem item={item}/>
					</React.Fragment>
				)
			})}
		</div>
	);
};

export default DrMaxReserveMedicamentsList;
